import { css } from 'emotion';

import {
  ISettingsColors,
  ISettingsFonts,
} from '@wix/podcasts-common/dist/settings';

interface IGetStylesArgs {
  colors: ISettingsColors;
  fonts: ISettingsFonts;
}

interface IEnclosureStyles {
  enclosureContainer: string;
  enclosureWrapper: string;
}

function getAudioStyles({ colors, fonts }: IGetStylesArgs): IEnclosureStyles {
  return {
    enclosureWrapper: css({
      backgroundColor: colors.episode.headerBackgroundColor,
    }),
    enclosureContainer: css({
      color: colors.episode.playerControlsColor,
    }),
  };
}

function getVideoStyles({ colors, fonts }: IGetStylesArgs): IEnclosureStyles {
  return {
    enclosureWrapper: css({
      backgroundColor: colors.episode.contentBackgroundColor,
    }),
    enclosureContainer: css({}),
  };
}

export { getAudioStyles, getVideoStyles, IEnclosureStyles };
